<template>
  <ProductListDialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="visible"
    :show-close-btn="showCloseBtn"
    :show-btn="showBtn"
    :popup-width="'1000px'"
    @resetPopupData="resetPopupData"
  >
    <e-search
      :data="filterInfo.data"
      :field-list="filterInfo.fieldList"
      class="margin-b20"
      @handleFilter="handleFilter"
      @handleReset="handleReset"
      @handleFocus="focusClassify"
    ></e-search>
    <eui-btn type="primary" class="margin-b20" @click="centralizedSkuExportCentralizedSku">导出</eui-btn>
    <TableList
      :table-data="tableData"
      :table-label="tableLabel"
      :loading="loading"
      :selection-show="multipleSelection"
      max-height="240"
    >
      <template #confirmStatus="slot">
        {{ formatConfirmStatus(slot.scope.row.comfirmStatus) }}
      </template>
      <template #rate="slot">
        {{ formatRate(slot.scope.row) }}
      </template>
    </TableList>

    <div class="pagination">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="productTagPage.currentPage"
        :page-size="productTagPage.pageSize"
        :total="productTagPage.pageTotal"
        :small="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
      <!-- 所属分类 -->
      <classifyTree
        v-if="classifyVisible"
        :classify-visible="classifyVisible"
        :category-tree-data="categoryTreeData"
        :default-checked-keys="defaultCheckedKeys"
        @submitPopupData="classifySubmitPopupData"
        @resetPopupData="classifyResetPopupData"
      ></classifyTree>
    </div>
  </ProductListDialog>
</template>

<script>
import ProductListDialog from '@/modules/projectA/components/common/e-dialog';
import TableList from '@/modules/projectA/components/common/e-table-list';
import eSearch from '@/modules/projectA/components/common/e-search';
import utils from '@/modules/projectA//utils/utils';
import api from '../../../api/product/index';
import agreementApi from '../../../api/agreement/index';
import classifyTree from './classifyTree';

export default {
  name: 'ProductDialog',
  components: {
    ProductListDialog,
    TableList,
    eSearch,
    classifyTree,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    userIdentity: {
      type: Number,
      default: 0,
    },
    agreementId: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      classifyVisible: false,
      defaultCheckedKeys: [],
      categoryTreeData: [],
      filterInfo: {
        data: {
          skuCode: null,
          skuName: null,
          brandName: null,
          categoryName: null,
        },
        fieldList: [
          { label: '商品编号', type: 'input', value: 'skuCode', width: '180' },
          { label: '商品名称', type: 'input', value: 'skuName' },
          {
            label: '类目名称',
            type: 'dialog',
            value: 'categoryName',
            placeholder: '支持多选',
          },
          { label: '品牌名称', type: 'input', value: 'brandName' },
        ],
      },
      showCloseBtn: true,
      showBtn: false,
      loading: false,
      tableData: [],
      tableLabel: [
        { label: '商品编号', param: 'skuCode', align: 'center' },
        { label: '商品名称', param: 'skuName', align: 'center' },
        { label: '类目名称', param: 'categoryName', align: 'center' },
        { label: '计量单位', param: 'unitValue', align: 'center' },
        { label: '品牌', param: 'brandName', align: 'center' },
        { label: '平台价（元）', param: 'price', align: 'center' },
        { label: '惠享价（元）', param: 'sharePrice', align: 'center' },
        { label: '集采价（元）', param: 'agreementPrice', align: 'center' },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      query: {
        categoryIdList: [],
        brandName: '',
        skuCode: '',
        skuName: '',
      },
      dialogTitle: '商品清单',
      multipleSelection: false,
    };
  },
  computed: {},
  created() {
    this.getProductPriceList();
  },
  methods: {
    async centralizedSkuExportCentralizedSku() {
      const params = this.formatParams();
      const res = await api.centralizedSkuExportCentralizedSku(params);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '商品清单导出');
      }
    },
    // 获取分类树数据
    async getAllCategoryTree() {
      const res = await agreementApi.queryCentralizedCategoryTreeByAgreementId({
        agreementId: this.agreementId,
      });
      if (res.code === '200') {
        this.categoryTreeData = res.data.children;
      }
    },
    // 选择所属分类
    focusClassify() {
      this.getAllCategoryTree();
      if (this.query.categoryIdList?.length) {
        this.defaultCheckedKeys = this.query.categoryIdList;
      }
      this.classifyVisible = true;
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      const filterNode = [];
      val.map((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.query.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.filterInfo.data.categoryName = arr.join('、');
      this.classifyVisible = false;
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },
    handleFilter(val) {
      this.query.brandName = val.brandName;
      this.query.skuCode = val.skuCode;
      this.query.skuName = val.skuName;
      this.productTagPage.currentPage = 1;

      this.getProductPriceList();
    },
    handleReset() {
      this.query.skuName = null;
      this.query.skuCode = null;
      this.query.brandName = null;
      this.query.categoryIdList = null;
      this.productTagPage.currentPage = 1;
      this.filterInfo.data.categoryName = null;
      this.getProductPriceList();
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.getProductPriceList();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.getProductPriceList();
    },
    resetPopupData() {
      this.$emit('close');
    },
    getProductPriceList() {
      const params = this.formatParams();
      api.queryAuditSkuPage(params).then((res) => {
        if (res.data) {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
        }
      });
    },
    formatParams() {
      const res = {};
      res.pageNum = this.productTagPage.currentPage;
      res.pageSize = this.productTagPage.pageSize;
      res.agreementId = this.agreementId;
      res.skuName = this.query.skuName;
      res.skuCode = this.query.skuCode;
      res.brandName = this.query.brandName;
      res.categoryIdList = this.query.categoryIdList;
      res.userIdentity = this.userIdentity == 2 ? 'purchase' : '';
      res.supplierCompanyId = this.supplierCompanyId;
      return res;
    },
    formatConfirmStatus(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '未提交';
          break;
        case 1:
          res = '待确认';
          break;
        case 2:
          res = '已确认';
          break;
        case 3:
          res = '拒绝';
          break;
      }
      return res;
    },
    formatRate(row) {
      return row.agreementPrice ? `${(((row.price - row.agreementPrice) / row.price) * 100).toFixed(2)}%` : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
